import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setDocumentSource
} from '../redux/documentSources'

export default function * requestChangeDocumentSourceName (action) {
  const { id, name, resolve, reject } = action.payload

  const optimisticAction = yield optimisticPut(setDocumentSource({
    id,
    name
  }))

  try {
    yield call(apiAction, 'RenameDocumentsSource', {
      id,
      name
    })

    yield optimisticAction.commit()

    resolve()
  } catch (error) {
    yield optimisticAction.revert()

    reject(error)

    if (
      error.code !== 300 && // Duplicate
      error.code !== 303 // NoChange
    ) {
      throw error
    }
  }
}
